import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { TextField, InputAdornment } from 'material-ui';
import { Image, Label } from 'semantic-ui-react';
import { ReduxFormField } from 'components';

import moment from 'moment';
import 'moment/locale/ko';
import 'moment/locale/ja';

import classNames from 'classnames/bind';
import styles from './ReduxFormCommon.css';
const cx = classNames.bind(styles);

moment.locale(localStorage.getItem('language'));

class renderField extends PureComponent {
  componentDidMount() {
    const { input, defaultValue } = this.props;

    if (typeof defaultValue !== 'undefined' && (typeof input.value === 'undefined' || input.value === '')) {
      input.onChange(defaultValue);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { startDate } = this.props;

    if (startDate && startDate !== nextProps.startDate && nextProps.input.value < nextProps.startDate) {
      nextProps.input.onChange(null);
    }
  }

  render() {
    const {
      input,
      meta,
      checkType,
      className,
      inputLabel,
      defaultValue,
      dateFormat,
      noerror,
      error,
      validate,
      helperText,
      helperTextClassName,
      required,
      warn,
      refPass,
      ...rest
    } = this.props;

    let isError = false;
    if (!noerror && (meta.dirty || meta.touched) && meta.visited && meta.error) {
      isError = true;
    }

    return (
      <div className={cx(className)}>
        <div className={cx('pointing-label-area')}>
          {isError ? (
            <Label className={cx('pointing-label')} basic pointing>
              {meta.error}
            </Label>
          ) : null}
        </div>
        {/* <div className={cx('field-textfield-material', className)}> */}
        <DatePicker
          autoComplete="off"
          className={cx(error ? 'validate-error' : '')}
          {...input}
          // onBlur 시 값이 업데이트 되는것을 방지
          onBlur={() => {
            input.onBlur();
          }}
          dateFormat={dateFormat}
          customInput={
            <TextField
              fullWidth
              // autoComplete="off"
              label={inputLabel ? inputLabel + (required ? ' *' : '') : ''}
              error={isError || error}
              helperText={helperText}
              helperTextClassName={helperTextClassName}
              InputProps={{
                onKeyDown: e => {
                  e.preventDefault();
                },
                endAdornment: (
                  <InputAdornment position="start">
                    <Image className={cx('cal-icon')} src="/img/common/btn_cal.png" />
                  </InputAdornment>
                )
              }}
            />
          }
          selected={input.value ? moment(input.value, dateFormat) : null}
          ref={refPass}
          {...rest}
        />
      </div>
    );
  }
}

const ReduxFormDatePicker = ({ ...rest }) => {
  return <ReduxFormField component={renderField} {...rest} />;
};

ReduxFormDatePicker.propTypes = {
  checkType: PropTypes.number
};
ReduxFormDatePicker.defaultProps = {
  checkType: 99
};

export default ReduxFormDatePicker;



// WEBPACK FOOTER //
// ./src/script/components/reduxForm/ReduxFormDatePicker.js